import type { UserTableView, UserTableViewApiId } from '@/model/UserTableView.model.ts';

export const VIEW_NAME_MAX_LENGTH = 100;

export const MAX_VIEWS_PER_TABLE = 10;

const RESERVED_NAMES = new Set(['default']);

export const validateViewName = (
  value: string,
  views: Array<UserTableView>,
  excludeApiId?: UserTableViewApiId
): string | true => {
  const trimmed = value.trim();

  if (trimmed === '') {
    return 'Please enter a name for this view';
  }

  if (trimmed.length > VIEW_NAME_MAX_LENGTH) {
    return `Name must be ${VIEW_NAME_MAX_LENGTH} characters or fewer`;
  }

  if (RESERVED_NAMES.has(trimmed.toLowerCase())) {
    return 'This name is reserved';
  }

  const isTaken = views.some(
    (view) => view.api_id !== excludeApiId && view.name.toLowerCase() === trimmed.toLowerCase()
  );
  if (isTaken) {
    return 'A view with this name already exists';
  }

  return true;
};
